module.exports = __webpack_public_path__ + "static/media/paypal.d3035b8f.png";